import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { ImageDescriptionSlideoutItemType } from '@application/Types/ComponentTypes'

import { ImageWrapper, Subtitle, Title, Wrapper } from './ImageDescriptionSlideoutItem.styled'

export type MemberProps = ImageDescriptionSlideoutItemType & {
    className?: string
}

export const ImageDescriptionSlideoutItem = ({ title, subtitle, image, className }: MemberProps): JSX.Element => {
    return (
        <Wrapper className={className}>
            <ImageWrapper>{image && <Image image={image} />}</ImageWrapper>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
        </Wrapper>
    )
}
